import { makeVar } from "@apollo/client";

export const menuLanguageVersionVar = makeVar<string | null>(null);
